import {useEffect, useMemo, useState} from "react";
import {css} from "@panda/css";
import * as lscache from "lscache";

import {Button} from "@pg-design/button-module";
import {CloseIcon, PhoneIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {HOTLINE_MODAL_CLOSED_KEY} from "../../app/constants/storage_keys";
import {getRandomConsultant} from "../../application/utils/lead/get_random_consultant";
import {RPModal} from "../../atoms/RPModal";
import {HOTLINE_MODAL_PHONE_NUMBER} from "../constants/hotline_phone_numbers";

const HOTLINE_MODAL_EXPIRATION_MINUTES = 24 * 60; // 24 hours

export const HotlineModal = () => {
    const {isMobile} = useUserDevice();

    const [isOpen, setIsOpen] = useState(false);
    const consultant = useMemo(() => getRandomConsultant(), []);
    const hotlinePhoneFormat = phoneNumberFormat(HOTLINE_MODAL_PHONE_NUMBER);

    useEffect(() => {
        const wasClosed = lscache.get(HOTLINE_MODAL_CLOSED_KEY);
        if (wasClosed) {
            return;
        }

        const timer = setTimeout(() => {
            if (!isOpen) {
                setIsOpen(true);
            }
        }, 55000);

        return () => clearTimeout(timer);
    }, []);

    const handleClose = () => {
        lscache.set(HOTLINE_MODAL_CLOSED_KEY, true, HOTLINE_MODAL_EXPIRATION_MINUTES);
        setIsOpen(false);
    };

    return (
        <RPModal
            isOpen={isOpen}
            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.HOTLINE_DELAYED_MODAL}
            closeButton={(onModalClose) => (
                <CloseIcon
                    size="2"
                    wrapperSize="4.8"
                    wrapperType="circle"
                    wrapperColor={isMobile ? "#fff" : "transparent"}
                    onClick={onModalClose}
                    className={closeButtonStyle}
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.HOTLINE_DELAYED_MODAL_CLOSE_BUTTON}
                />
            )}
            onModalClose={handleClose}
            className={phoneModalStyle}
        >
            <div className={containerStyle}>
                <Text variant="headline_4" as="p" align="center" mb={3}>
                    Potrzebujesz pomocy ze znalezieniem mieszkania?
                </Text>
                <Image width="128" height="128" src={consultant.image.s144} alt="zdjęcie konsultanta" className={consultantStyle} />
                <Text variant="headline_4" as="p" align="center">
                    {consultant.fullName}
                </Text>
                <Text variant="info_txt_1" as="p" align="center" color="var(--colors-gray-800)" mb={3}>
                    Konsultant mieszkaniowy
                </Text>
                {isMobile ? (
                    <Text variant="body_copy_2" as="p" align="center" mb={3}>
                        Powiedz mi, jakiego mieszkania szukasz, a <span className={css({fontWeight: "700"})}>bezpłatnie i szybko</span> znajde dla Ciebie oferty
                        spełniające Twoje oczekiwania oraz doradzę w wyborze najlepszej!
                    </Text>
                ) : (
                    <Text variant="body_copy_2" as="p" align="center" mb={3}>
                        Powiedz, jakiego mieszkania szukasz, a bezpłatnie przygotuję dla Ciebie dopasowane oferty i doradzę w wyborze najlepszej.
                    </Text>
                )}
                {isMobile ? (
                    <Button
                        variant="filled_primary"
                        iconLeft={PhoneIcon}
                        href={`tel:+${hotlinePhoneFormat}`}
                        dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PHONE_MODAL_NUMBER_PLACEHOLDER}
                    >
                        {hotlinePhoneFormat}
                    </Button>
                ) : (
                    <div className={hotlineWrapper}>
                        <PhoneIcon size="2" wrapperSize="3" wrapperColor="var(--colors-primary)" />
                        <Text variant="body_copy_2" as="p" dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PHONE_MODAL_NUMBER_PLACEHOLDER}>
                            Zadzwoń: <span className={hotlineNumberStyle}>{hotlinePhoneFormat}</span>
                        </Text>
                    </div>
                )}
            </div>
        </RPModal>
    );
};

const phoneModalStyle = css({
    bottom: -1,
    p: 4,
    borderRadius: 2,
    overflow: "unset",
    width: "100%",

    md: {
        bottom: "unset",
        maxWidth: "460px"
    }
});

const closeButtonStyle = css({
    cursor: "pointer",
    position: "absolute",
    top: -7,
    right: "50%",
    transform: "translate(50%, 0)",
    md: {
        top: -3,
        right: -3,
        transform: "unset"
    }
});

const consultantStyle = css({
    borderRadius: "50%",
    objectFit: "cover",
    mb: 2,
    alignSelf: "center"
});

const containerStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
});

const hotlineWrapper = css({
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: 1
});

const hotlineNumberStyle = css({
    fontWeight: "700",
    fontSize: "15.75px",
    ml: 1
});
import {useEffect, useMemo, useState} from "react";
import {css} from "@panda/css";
import * as lscache from "lscache";

import {Button} from "@pg-design/button-module";
import {CloseIcon, PhoneIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {HOTLINE_MODAL_CLOSED_KEY} from "../../app/constants/storage_keys";
import {getRandomConsultant} from "../../application/utils/lead/get_random_consultant";
import {RPModal} from "../../atoms/RPModal";
import {HOTLINE_MODAL_PHONE_NUMBER} from "../constants/hotline_phone_numbers";

const HOTLINE_MODAL_EXPIRATION_MINUTES = 24 * 60; // 24 hours

export const HotlineModal = () => {
    const {isMobile} = useUserDevice();

    const [isOpen, setIsOpen] = useState(false);
    const consultant = useMemo(() => getRandomConsultant(), []);
    const hotlinePhoneFormat = phoneNumberFormat(HOTLINE_MODAL_PHONE_NUMBER);

    useEffect(() => {
        const wasClosed = lscache.get(HOTLINE_MODAL_CLOSED_KEY);
        if (wasClosed) {
            return;
        }

        const timer = setTimeout(() => {
            if (!isOpen) {
                setIsOpen(true);
            }
        }, 55000);

        return () => clearTimeout(timer);
    }, []);

    const handleClose = () => {
        lscache.set(HOTLINE_MODAL_CLOSED_KEY, true, HOTLINE_MODAL_EXPIRATION_MINUTES);
        setIsOpen(false);
    };

    return (
        <RPModal
            isOpen={isOpen}
            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.HOTLINE_DELAYED_MODAL}
            closeButton={(onModalClose) => (
                <CloseIcon
                    size="2"
                    wrapperSize="4.8"
                    wrapperType="circle"
                    wrapperColor={isMobile ? "#fff" : "transparent"}
                    onClick={onModalClose}
                    className={closeButtonStyle}
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.HOTLINE_DELAYED_MODAL_CLOSE_BUTTON}
                />
            )}
            onModalClose={handleClose}
            className={phoneModalStyle}
        >
            <div className={containerStyle}>
                <Text variant="headline_4" as="p" align="center" mb={3}>
                    Potrzebujesz pomocy ze znalezieniem mieszkania?
                </Text>
                <Image width="128" height="128" src={consultant.image.s144} alt="zdjęcie konsultanta" className={consultantStyle} />
                <Text variant="headline_4" as="p" align="center">
                    {consultant.fullName}
                </Text>
                <Text variant="info_txt_1" as="p" align="center" color="var(--colors-gray-800)" mb={3}>
                    Konsultant mieszkaniowy
                </Text>
                {isMobile ? (
                    <Text variant="body_copy_2" as="p" align="center" mb={3}>
                        Powiedz mi, jakiego mieszkania szukasz, a <span className={css({fontWeight: "700"})}>bezpłatnie i szybko</span> znajde dla Ciebie oferty
                        spełniające Twoje oczekiwania oraz doradzę w wyborze najlepszej!
                    </Text>
                ) : (
                    <Text variant="body_copy_2" as="p" align="center" mb={3}>
                        Powiedz, jakiego mieszkania szukasz, a bezpłatnie przygotuję dla Ciebie dopasowane oferty i doradzę w wyborze najlepszej.
                    </Text>
                )}
                {isMobile ? (
                    <Button
                        variant="filled_primary"
                        iconLeft={PhoneIcon}
                        href={`tel:+${hotlinePhoneFormat}`}
                        dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PHONE_MODAL_NUMBER_PLACEHOLDER}
                    >
                        {hotlinePhoneFormat}
                    </Button>
                ) : (
                    <div className={hotlineWrapper}>
                        <PhoneIcon size="2" wrapperSize="3" wrapperColor="var(--colors-primary)" />
                        <Text variant="body_copy_2" as="p" dataTestId={OFFER_TEST_IDS.OFFER_VIEW.PHONE_MODAL_NUMBER_PLACEHOLDER}>
                            Zadzwoń: <span className={hotlineNumberStyle}>{hotlinePhoneFormat}</span>
                        </Text>
                    </div>
                )}
            </div>
        </RPModal>
    );
};

const phoneModalStyle = css({
    bottom: -1,
    p: 4,
    borderRadius: 2,
    overflow: "unset",
    width: "100%",

    md: {
        bottom: "unset",
        maxWidth: "460px"
    }
});

const closeButtonStyle = css({
    cursor: "pointer",
    position: "absolute",
    top: -7,
    right: "50%",
    transform: "translate(50%, 0)",
    md: {
        top: -3,
        right: -3,
        transform: "unset"
    }
});

const consultantStyle = css({
    borderRadius: "50%",
    objectFit: "cover",
    mb: 2,
    alignSelf: "center"
});

const containerStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
});

const hotlineWrapper = css({
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: 1
});

const hotlineNumberStyle = css({
    fontWeight: "700",
    fontSize: "15.75px",
    ml: 1
});
